import React from 'react'
import styled from 'react-emotion'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import Hero from '../components/hero'
import ImageStack from '../components/image-stack'
import Benefits from '../components/benefits'
import Layout from '../layouts'

const MainWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column'
})

const IndexPage = () => (
  <Layout>
    <MainWrapper>
      <Navigation />
      <Hero />
      <ImageStack />
      <Benefits />
      <Footer />
    </MainWrapper>
  </Layout>
)

export default IndexPage
